import { useState, useEffect, type ReactNode, type ReactElement } from 'react';

/**
 * Suppresses server-side rendering of its children.
 * On the server (or during hydration), renders `fallback` instead.
 * Once the component mounts on the client, renders `children`.
 *
 * Replaces the `ssr: false` option previously provided by `next/dynamic`.
 */
export function NoSsr({
  children,
  fallback = null,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}): ReactElement {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return <>{mounted ? children : fallback}</>;
}
